export class PaginationApi<T> {
  page: number = 1;
  per_page: number = 10;
  totalResults: number = 0;
  totalPages: number = 0;
  showingResults: number = 0;
  nextPage: number;
  previousPage: number;
  results: T[];

  constructor(attrs?: Partial<PaginationApi<T>>) {
    Object.assign(this, attrs);
    this.results = attrs?.results?.map((item) => <T>item);
  }
}
